export enum ActionNotificationTiggerForms {
	warningTriggers = "warningTriggers",
	dueTriggers = "dueTriggers"
}